import React from 'react';
import Button from '@mui/material/Button';
import Popover from '@mui/material/Popover';
import PropTypes from 'prop-types';
import ConstituentSearchField from '@/components/common/form/ConstituentSearchField';
import translate from '@/lib/intl/translate';
import { useLifecycleBoardContext } from './LifecycleBoardContext';

function AddConstituent({ className, columnId }) {
  const [anchorEl, setAnchorEl] = React.useState(false);
  const [selectedConstituent, setSelectedConstituent] = React.useState(null);
  const { addConstituentToColumn, board } = useLifecycleBoardContext();
  const handleAdd = async (e) => {
    e.preventDefault();
    if (!selectedConstituent) return;
    await addConstituentToColumn(selectedConstituent.value, columnId);
    setAnchorEl(null);
  };
  const id = `add-constituent-${columnId}`;
  return (
    <div className={className}>
      <Button
        color="primary"
        className="w-full"
        onClick={(e) => {
          setAnchorEl(e.target);
          e.target.blur();
        }}
        aria-describedby={id}
      >
        {translate('ADD_CONSTITUENT')}
      </Button>
      <Popover
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        id={id}
        open={!!anchorEl}
        onClose={() => setAnchorEl(false)}
        className="w-full"
      >
        <form className="w-75" onSubmit={handleAdd} autoComplete="off">
          <div className="px-4 pt-4">
            <ConstituentSearchField
              label={translate('CONSTITUENT_SEARCH')}
              params={{ excludeBoardId: board.boardId }}
              value={selectedConstituent}
              setValue={(val) => setSelectedConstituent(val)}
            />
          </div>
          <div className="flex w-full justify-end border-t border-grey-300 p-4">
            <Button
              color="primary"
              className="h-12"
              onClick={() => setAnchorEl(false)}
              size="small"
            >
              {translate('CANCEL')}
            </Button>
            <Button
              color="primary"
              className="h-12"
              variant="contained"
              disabled={!selectedConstituent}
              type="submit"
              size="small"
            >
              {translate('ADD')}
            </Button>
          </div>
        </form>
      </Popover>
    </div>
  );
}

AddConstituent.propTypes = {
  className: PropTypes.string,
  columnId: PropTypes.string.isRequired,
};

AddConstituent.defaultProps = {
  className: '',
};

export default AddConstituent;
